import React from 'react';
import PropTypes from 'prop-types';
import css from './ConnectionItemPlaceholder.scss';
import { range } from 'lodash';

export default class ConnectionItemPlaceholder extends React.Component {

  get lines() {
    return (
      <div className={css['lines-container']}>
        <p className={css['main-line']}>&nbsp;</p>
        {range(this.props.numberOfLines - 1).map(i => <p key={i} className={css['secondary-line']}>&nbsp;</p>)}
      </div>
    );
  }

	render() {
		return (
			<div className={css['item-container']}>
				<div className={css['avatar']}></div>
				{this.lines}
			</div>
		);
	}
}

ConnectionItemPlaceholder.defaultProps = {
  numberOfLines: 2
};

ConnectionItemPlaceholder.propTypes = {
  numberOfLines: PropTypes.number.isRequired
};
